"use client";
import React, { useEffect, useState } from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import Data from "@/app/data/blog/blogs.json";

function BlogNavigation() {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Only set currentUrl if window is available
      const path = window.location.pathname;
      setCurrentUrl(path); // Save the pathname from URL
    }
  }, []);

  const currentIndex = Data?.findIndex((blog) => blog.link === currentUrl);
  const previousBlog = currentIndex > 0 ? Data[currentIndex - 1] : null;
  const nextBlog =
    currentIndex < Data?.length - 1 ? Data[currentIndex + 1] : null;

  return (
    <div className="mx-auto max-w-7xl px-6  ">
      <div className="">
        <hr className="mt-5 " />
      </div>

      <div className="grid mb-1  grid-cols-12 gap-6   bg-white ">
        {/* Previous Blog Link */}
        <div className="col-span-6 flex items-start gap-4 pt-4 mb-4">
          {previousBlog ? (
            <a
              href={previousBlog.link}
              className="flex flex-col gap-2 items-start text-lg font-semibold text-[#2B3252]"
            >
              <div>
                <div className="inline-block  flex justify-start items-center gap-2 hover:text-[#D5AF34]">
                  <FaArrowLeftLong className="text-xl" />
                  <span>Back to</span>
                </div>
                <span className="text-center text-sm text-[#2B3252] mt-1">
                  {previousBlog.description}
                </span>
              </div>
            </a>
          ) : (
            <span className="text-gray-400 font-semibold flex gap-3 items-center">
              <FaArrowLeftLong className="text-xl" />
              <span>No Previous Blog</span>
            </span>
          )}
        </div>

        {/* Next Blog Link */}
        <div className="col-span-6 flex justify-end  items-center">
          {nextBlog ? (
            <a
              href={nextBlog.link}
              className="flex flex-col gap-2 items-center text-lg font-semibold text-[#2B3252]  rounded-lg "
            >
              <div className=" grid text-right justify-end">
                <div className="flex justify-end mb-1 items-center gap-2 hover:text-[#D5AF34]">
                  <span>Next Blog</span>
                  <FaArrowRightLong className="text-xl" />
                </div>
                <p className=" text-sm  text-[#2B3252]">
                  {nextBlog.description}
                </p>
              </div>
            </a>
          ) : (
            <div className="text-gray-400 font-semibold">No Next Blog</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BlogNavigation;
